import {
  NEPAL_DESCRIPTION_LIST_FAIL,
  NEPAL_DESCRIPTION_LIST_REQUEST,
  NEPAL_DESCRIPTION_LIST_SUCCESS,
  NEPAL_DESCRIPTION_UPDATE_FAIL,
  NEPAL_DESCRIPTION_UPDATE_REQUEST,
  NEPAL_DESCRIPTION_UPDATE_RESET,
  NEPAL_DESCRIPTION_UPDATE_SUCCESS,
} from "../constants/aboutNepalConstant";

export const listNepalDescriptionReducer = (state = {}, action) => {
  switch (action.type) {
    case NEPAL_DESCRIPTION_LIST_REQUEST:
      return {
        loading: true,
      };
    case NEPAL_DESCRIPTION_LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        descriptions: action.payload,
      };

    case NEPAL_DESCRIPTION_LIST_FAIL:
      return {
        loading: true,
        success: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export const nepalDescriptionEditReducer = (state = {}, action) => {
  switch (action.type) {
    case NEPAL_DESCRIPTION_UPDATE_REQUEST:
      return {
        loading: true,
      };
    case NEPAL_DESCRIPTION_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
      };
    case NEPAL_DESCRIPTION_UPDATE_FAIL:
      return {
        loading: true,
        error: action.payload,
      };
    case NEPAL_DESCRIPTION_UPDATE_RESET:
      return {
        loading: true,
        success: false,
      };
    default:
      return state;
  }
};
